module.exports = __webpack_public_path__ + "assets/img/Jurong East MRT Interchange.898fa792.jpg";